"use strict";
/*
 * Created on 25. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var PriceFormulas_1 = require("../../core/model/math/PriceFormulas");

var utils_1 = require("../../core/utils");

var RangeConverter_1 = require("../../general-settings/conversions/constraint/RangeConverter");

var OptimizationGoalsSettings_1 = require("../../general-settings/model/optimalization-goal/OptimizationGoalsSettings");

var ImpactRecordSums_1 = require("../model/ImpactRecordSums");

var ImpactRecordSumsConverter_1 = require("./ImpactRecordSumsConverter");
/**
 * Default implementation of {@link ImpactRecordSumsConverter}.
 *
 * @author Radek Beran
 */


var ImpactRecordSumsConverterImpl =
/*#__PURE__*/
function (_ImpactRecordSumsConv) {
  _inherits(ImpactRecordSumsConverterImpl, _ImpactRecordSumsConv);

  function ImpactRecordSumsConverterImpl(rangeConverter) {
    var _this;

    _classCallCheck(this, ImpactRecordSumsConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ImpactRecordSumsConverterImpl).call(this));
    _this.rangeConverter = rangeConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(ImpactRecordSumsConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new ImpactRecordSums_1.ImpactRecordSums(conversions.documentToClassId(source), conversions.toClassReferenceId(source.releaseId), conversions.toClassReferenceId(source.categoryId), conversions.toClassReferenceId(source.priceZoneId), utils_1.Utils.isObject(source.marginConstraint) ? this.rangeConverter.toObject(source.marginConstraint, conversions) : null, conversions.asEnumOpt(source.optimizationGoal, OptimizationGoalsSettings_1.OptimizationGoal), source.exportedCount, source.storesCount, !utils_1.Utils.isValueMissing(source.marginOldUpperSum) ? conversions.toBigNumber(source.marginOldUpperSum) : PriceFormulas_1.PriceFormulas.ZERO, !utils_1.Utils.isValueMissing(source.marginOldWeightSum) ? conversions.toBigNumber(source.marginOldWeightSum) : PriceFormulas_1.PriceFormulas.ZERO, !utils_1.Utils.isValueMissing(source.marginNewUpperSum) ? conversions.toBigNumber(source.marginNewUpperSum) : PriceFormulas_1.PriceFormulas.ZERO, !utils_1.Utils.isValueMissing(source.marginNewWeightSum) ? conversions.toBigNumber(source.marginNewWeightSum) : PriceFormulas_1.PriceFormulas.ZERO, !utils_1.Utils.isValueMissing(source.revenueOldUpperSum) ? conversions.toBigNumber(source.revenueOldUpperSum) : PriceFormulas_1.PriceFormulas.ZERO, !utils_1.Utils.isValueMissing(source.revenueOldWeightSum) ? conversions.toBigNumber(source.revenueOldWeightSum) : PriceFormulas_1.PriceFormulas.ZERO, !utils_1.Utils.isValueMissing(source.revenueNewUpperSum) ? conversions.toBigNumber(source.revenueNewUpperSum) : PriceFormulas_1.PriceFormulas.ZERO, !utils_1.Utils.isValueMissing(source.revenueNewWeightSum) ? conversions.toBigNumber(source.revenueNewWeightSum) : PriceFormulas_1.PriceFormulas.ZERO, !utils_1.Utils.isValueMissing(source.profitOldUpperSum) ? conversions.toBigNumber(source.profitOldUpperSum) : PriceFormulas_1.PriceFormulas.ZERO, !utils_1.Utils.isValueMissing(source.profitOldWeightSum) ? conversions.toBigNumber(source.profitOldWeightSum) : PriceFormulas_1.PriceFormulas.ZERO, !utils_1.Utils.isValueMissing(source.profitNewUpperSum) ? conversions.toBigNumber(source.profitNewUpperSum) : PriceFormulas_1.PriceFormulas.ZERO, !utils_1.Utils.isValueMissing(source.profitNewWeightSum) ? conversions.toBigNumber(source.profitNewWeightSum) : PriceFormulas_1.PriceFormulas.ZERO);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this2 = this;

      var document = {};
      Object.assign(document, conversions.classToDocumentId(source));
      Object.assign(document, {
        releaseId: conversions.toDocumentReferenceId(source.releaseId),
        categoryId: conversions.toDocumentReferenceId(source.categoryId),
        priceZoneId: conversions.toDocumentReferenceId(source.priceZoneId),
        marginConstraint: source.marginConstraint !== null ? conversions.asObject(source, 'marginConstraint', function (range) {
          return _this2.rangeConverter.toDocument(source.marginConstraint, conversions);
        }) : null,
        optimizationGoal: source.optimizationGoal !== null ? source.optimizationGoal.toString() : null,
        exportedCount: source.exportedCount,
        storesCount: source.storesCount,
        marginOldUpperSum: conversions.fromBigNumber(source.marginOldUpperSum),
        marginOldWeightSum: conversions.fromBigNumber(source.marginOldWeightSum),
        marginNewUpperSum: conversions.fromBigNumber(source.marginNewUpperSum),
        marginNewWeightSum: conversions.fromBigNumber(source.marginNewWeightSum),
        revenueOldUpperSum: conversions.fromBigNumber(source.revenueOldUpperSum),
        revenueOldWeightSum: conversions.fromBigNumber(source.revenueOldWeightSum),
        revenueNewUpperSum: conversions.fromBigNumber(source.revenueNewUpperSum),
        revenueNewWeightSum: conversions.fromBigNumber(source.revenueNewWeightSum),
        profitOldUpperSum: conversions.fromBigNumber(source.profitOldUpperSum),
        profitOldWeightSum: conversions.fromBigNumber(source.profitOldWeightSum),
        profitNewUpperSum: conversions.fromBigNumber(source.profitNewUpperSum),
        profitNewWeightSum: conversions.fromBigNumber(source.profitNewWeightSum)
      });
      return document;
    }
  }]);

  return ImpactRecordSumsConverterImpl;
}(ImpactRecordSumsConverter_1.ImpactRecordSumsConverter);

ImpactRecordSumsConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [RangeConverter_1.RangeConverter])], ImpactRecordSumsConverterImpl);
exports.ImpactRecordSumsConverterImpl = ImpactRecordSumsConverterImpl;